<div>
  <ul class="tab-group" [ngClass]="{'flexible': isFlexible}">
    @for (tabName of tabNameList; track tabName; let idx = $index) {
      <li [ngClass]="{'selected': idx === selectedTabIdx}">
        <button (click)="changeTab(idx)">{{tabName}}</button>
      </li>
    }
  </ul>

  <div #tabContentGroup class="tab-content-group" (cdkObserveContent)="onContentChange()">
    <ng-content></ng-content>
  </div>
</div>
